import React, { useState } from "react"
import { CgClose } from "react-icons/cg"
import { FaCloudUploadAlt } from "react-icons/fa"
import { MdDelete } from "react-icons/md"
import uploadImage from "../helpers/uploadImage"
import SummaryApi from "../common"
import { toast } from "react-toastify"

const brands = ["Dell","HP","Lenovo","Asus","Acer","Apple"]

const categories = ["Gaming Laptop","Business Laptop","2in1","Ultrabook","Desktop"
]
const screenSizes = ["13.3", "14", "15.6", "16", "17"]
const processors = ["i3","i5", "i7", "i9", "Ryzen3", "Ryzen5", "Ryzen7"]
const generations = ["5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th", "13th", "14th"]
const ramList = ["4GB", "8GB", "12GB", "16GB", "32GB"]
const storageList = ["256GB SSD", "512GB SSD", "1TB SSD", "1TB HHD", "512GB HDD", "256GB HDD"]

const UploadProduct = ({ onClose, fetchData }) => {

const [ramInput,setRamInput] = useState("")
const [storageInput,setStorageInput] = useState("")

const [variant,setVariant] = useState({
ram:"",
storage:"",
price:"",
stock:""
})

const [variants,setVariants] = useState([])

const [data,setData] = useState({

productName:"",
brand:"",
category:"",
screenSize: "",
processor: "",
generation: "",
ram:"",
storage: "",
price:"",
sellingPrice:"",
description:"",
condition:"Good",
warranty:"6 Months",
stock:1,

ramOptions:[],
storageOptions:[],

productImage:[],

specifications:{

  performance:{
    OperatingSystem:"",
    Windows:"",
    BIOS:"",
    processorBrand:"",
    processorName:"",
    generation:"",
    cores:"",
    clockSpeed:"",
    cache:"",
    gpu:""
  },

  memory:{
    ram:"",
    ramType:"",
    ramFrequency:"",
    expandableMemory:"",
    storageType:"",
    hdd:"",
    ssd:""
  },

  display:{
    screenSize:"",
    resolution:"",
    screenType:"",
    touchscreen:"",
    
  },

  general:{
    brand:"",
    modelNumber:"",
    series:"",
    color:"",
    type:"",
    batteryBackup:""
  },

  dimensions:{
    size:"",
    weight:""
  },

  additional:{
    webcam:"",
    keyboard:"",
    antivirus:"",
    fingerprint:""
  },

  os:{
    os:"",
    architecture:""
  },

  ports:{
    usb:"",
    hdmi:"",
    mic:"",
    cardReader:""
  },

  connectivity:{
    wifi:"",
    bluetooth:""
  }

}

})

/* BASIC INPUT */

const handleChange = (e)=>{
const {name,value}=e.target
setData(prev=>({...prev,[name]:value}))
}

/* SPEC INPUT */

const handleSpecChange=(section,field,value)=>{
setData(prev=>({
...prev,
specifications:{
...prev.specifications,
[section]:{
...prev.specifications[section],
[field]:value
}
}
}))
}

/* IMAGE UPLOAD */

const handleImageUpload = async(e)=>{

const file=e.target.files[0]

if(!file) return

const img = await uploadImage(file)

setData(prev=>({
...prev,
productImage:[...prev.productImage,img.url]
}))

}

const removeImage=(index)=>{

const arr=[...data.productImage]
arr.splice(index,1)

setData(prev=>({...prev,productImage:arr}))

}

/* ADD RAM */

const addRam = ()=>{

if(!ramInput) return

setData(prev=>({
...prev,
ramOptions:[...prev.ramOptions,ramInput.toLowerCase()]
}))

setRamInput("")

}

/* ADD STORAGE */

const addStorage = ()=>{

if(!storageInput) return

setData(prev=>({
...prev,
storageOptions:[...prev.storageOptions,storageInput]
}))

setStorageInput("")

}

/* ADD VARIANT */

const addVariant = ()=>{

if(!variant.ram || !variant.storage || !variant.price) return

setVariants(prev=>[...prev,variant])

setVariant({
ram:"",
storage:"",
price:"",
stock:""
})

}

const removeVariant = (index)=>{

const arr=[...variants]
arr.splice(index,1)
setVariants(arr)

}

/* SUBMIT */

const handleSubmit = async(e)=>{

e.preventDefault()

const payload = {
...data,
variants
}

const res = await fetch(SummaryApi.uploadProduct.url,{
method:"POST",
credentials:"include",
headers:{ "content-type":"application/json" },
body:JSON.stringify(payload)
})

const result = await res.json()

if(result.success){

toast.success("Product Added")

fetchData()
onClose()

}else{
toast.error(result.message)
}

}

return(

<div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4">

<div className="bg-white w-full max-w-6xl h-[90vh] overflow-y-auto rounded-xl p-6">

{/* HEADER */}

<div className="flex justify-between items-center mb-6">

<h2 className="text-2xl font-bold">
Add Laptop Product
</h2>

<CgClose
className="text-2xl cursor-pointer"
onClick={onClose}
/>

</div>

<form className="space-y-8" onSubmit={handleSubmit}>

{/* BASIC INFO */}

<div className="bg-gray-50 p-5 rounded-lg grid md:grid-cols-2 gap-4">

<input
name="productName"
placeholder="Product Name"
className="border p-2 rounded"
onChange={handleChange}
/>

<select name="brand" className="border p-2 rounded" onChange={handleChange}>
<option>Select Brand</option>
{brands.map(b=>(
<option key={b} value={b.toLowerCase()}>{b}</option>

))}
</select>

{/* <select name="category" className="border p-2 rounded" onChange={handleChange}>
<option>Select Category</option>
{categories.map(c=>(
<option key={c}>{c}</option>
))}
</select> */}

<select name="condition" className="border p-2 rounded" onChange={handleChange}>
<option>Fair</option>
<option>Good</option>
<option>Superb</option>
</select>

<input name="price" type="number" placeholder="Price" className="border p-2 rounded" onChange={handleChange}/>

<input name="sellingPrice" type="number" placeholder="Selling Price" className="border p-2 rounded" onChange={handleChange}/>

<input name="stock" type="number" placeholder="Stock" className="border p-2 rounded" onChange={handleChange}/>

<input name="warranty" placeholder="Warranty" className="border p-2 rounded" onChange={handleChange}/>

</div>


{/* 🔥 FILTER SECTION */}
<div className="grid grid-cols-2 md:grid-cols-3 gap-4">

<select name="category" className="input" onChange={handleChange}>
<option>Category</option>
{categories.map(c=>(<option key={c}>{c}</option>))}
</select>

<select name="screenSize" className="input" onChange={handleChange}>
<option>Screen Size</option>
{screenSizes.map(s=>(<option key={s}>{s}"</option>))}
</select>

<select name="processor" className="input" onChange={handleChange}>
<option>Processor</option>
{processors.map(p=>(<option key={p}>{p}</option>))}
</select>

<select name="generation" className="input" onChange={handleChange}>
<option>Generation</option>
{generations.map(g=>(<option key={g}>{g}</option>))}
</select>

<select name="ram" className="input" onChange={handleChange}>
<option>RAM</option>
{ramList.map(r=>(<option key={r}>{r}</option>))}
</select>

<select name="storage" className="input" onChange={handleChange}>
<option>Storage</option>
{storageList.map(s=>(<option key={s}>{s}</option>))}
</select>

</div>

{/* RAM OPTIONS */}

<div className="bg-gray-50 p-5 rounded-lg">

<h3 className="font-semibold mb-3">RAM Options</h3>

<div className="flex gap-2">

<input
value={ramInput}
onChange={e=>setRamInput(e.target.value)}
placeholder="Example: 8GB"
className="border p-2 rounded flex-1"
/>

<button type="button" onClick={addRam} className="bg-blue-600 text-white px-4 rounded">
Add
</button>

</div>

<div className="flex gap-2 mt-3 flex-wrap">

{data.ramOptions.map((ram,i)=>(
<span key={i} className="bg-gray-200 px-3 py-1 rounded text-sm">{ram}</span>
))}

</div>

</div>

{/* STORAGE OPTIONS */}

<div className="bg-gray-50 p-5 rounded-lg">

<h3 className="font-semibold mb-3">Storage Options</h3>

<div className="flex gap-2">

<input
value={storageInput}
onChange={e=>setStorageInput(e.target.value)}
placeholder="Example: 512GB SSD"
className="border p-2 rounded flex-1"
/>

<button type="button" onClick={addStorage} className="bg-blue-600 text-white px-4 rounded">
Add
</button>

</div>

<div className="flex gap-2 mt-3 flex-wrap">

{data.storageOptions.map((s,i)=>(
<span key={i} className="bg-gray-200 px-3 py-1 rounded text-sm">{s}</span>
))}

</div>

</div>

{/* VARIANTS */}

<div className="bg-gray-50 p-5 rounded-lg">

<h3 className="font-semibold mb-4">Variant Pricing</h3>

<div className="grid md:grid-cols-4 gap-3">

<select
className="border p-2 rounded"
value={variant.ram}
onChange={(e)=>setVariant({...variant,ram:e.target.value})}
>

<option>Select RAM</option>

{data.ramOptions.map(r=>(
<option key={r}>{r}</option>
))}

</select>

<select
className="border p-2 rounded"
value={variant.storage}
onChange={(e)=>setVariant({...variant,storage:e.target.value})}
>

<option>Select Storage</option>

{data.storageOptions.map(s=>(
<option key={s}>{s}</option>
))}

</select>

<input
type="number"
placeholder="Price"
className="border p-2 rounded"
value={variant.price}
onChange={(e)=>setVariant({...variant,price:e.target.value})}
/>

<input
type="number"
placeholder="Stock"
className="border p-2 rounded"
value={variant.stock}
onChange={(e)=>setVariant({...variant,stock:e.target.value})}
/>

</div>

<button
type="button"
onClick={addVariant}
className="mt-4 bg-blue-600 text-white px-4 py-2 rounded"
>
Add Variant
</button>

<div className="mt-4 space-y-2">

{variants.map((v,i)=>(
<div key={i} className="flex justify-between items-center border bg-white p-3 rounded">

<div>
<p className="font-medium">{v.ram} / {v.storage}</p>
<p className="text-sm text-gray-500">Stock : {v.stock}</p>
</div>

<p className="font-semibold text-green-600">₹ {v.price}</p>

<button onClick={()=>removeVariant(i)} className="text-red-500">
<MdDelete/>
</button>

</div>
))}

</div>

</div>

{/* IMAGE UPLOAD */}

<div className="bg-gray-50 p-5 rounded-lg">

<h3 className="font-semibold mb-3">Product Images</h3>

<label className="border-2 border-dashed h-40 flex flex-col justify-center items-center rounded-lg cursor-pointer hover:bg-gray-100">

<FaCloudUploadAlt size={40}/>

<input type="file" hidden onChange={handleImageUpload}/>

</label>

<div className="flex gap-3 mt-4 flex-wrap">

{data.productImage.map((img,i)=>(
<div key={i} className="relative">

<img src={img} className="w-24 h-24 object-cover rounded"/>

<button
type="button"
className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1"
onClick={()=>removeImage(i)}
>
<MdDelete/>
</button>

</div>
))}

</div>

</div>

{/* DESCRIPTION */}

<textarea
name="description"
placeholder="Product Description"
className="border p-3 rounded w-full"
rows="4"
onChange={handleChange}
/>

{/* SPECIFICATIONS */}

<div className="bg-gray-50 p-5 rounded-lg space-y-6">

<h3 className="text-xl font-semibold">
Technical Specifications
</h3>

{/* PERFORMANCE */}

<div>

<h4 className="font-semibold mb-2 text-gray-700">
Performance
</h4>

<div className="grid md:grid-cols-2 gap-3">

<input
placeholder="RAM Type"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("performance","ramType",e.target.value)}
/>

<input
placeholder="RAM Frequency"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("performance","ramFrequency",e.target.value)}
/>

<input
placeholder="RAM Size"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("performance","ramSize",e.target.value)}
/>

<input
placeholder="RAM Slots"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("performance","ramSlots",e.target.value)}
/>

<input
placeholder="Storage Interface"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("performance","storageInterface",e.target.value)}
/>

<input
placeholder="Processor"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("performance","processor",e.target.value)}
/>

<input
placeholder="GPU"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("performance","gpu",e.target.value)}
/>

</div>

</div>


{/* CONNECTIVITY */}

<div>

<h4 className="font-semibold mb-2 text-gray-700">
Connectivity
</h4>

<div className="grid md:grid-cols-2 gap-3">

<input
placeholder="Bluetooth"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("connectivity","bluetooth",e.target.value)}
/>

<input
placeholder="WiFi"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("connectivity","wifi",e.target.value)}
/>

<input
placeholder="HDMI"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("connectivity","hdmi",e.target.value)}
/>

<input
placeholder="USB Ports"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("connectivity","usb",e.target.value)}
/>

<input
placeholder="Audio Jack"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("connectivity","audioJack",e.target.value)}
/>

<input
placeholder="Type C"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("connectivity","typeC",e.target.value)}
/>

</div>

</div>


{/* DISPLAY */}

<div>

<h4 className="font-semibold mb-2 text-gray-700">
Display
</h4>

<div className="grid md:grid-cols-2 gap-3">

<input
placeholder="Display Size"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("display","displaySize",e.target.value)}
/>

<input
placeholder="Display Technology"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("display","displayTech",e.target.value)}
/>

<input
placeholder="Resolution"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("display","resolution",e.target.value)}
/>

<input
placeholder="Thickness"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("display","thickness",e.target.value)}
/>

<input
placeholder="Display Pin"
className="border p-2 rounded"
onChange={(e)=>handleSpecChange("display","displayPin",e.target.value)}
/>

</div>

</div>

</div>

<button className="bg-red-600 text-white py-3 px-6 rounded-lg hover:bg-red-700">
Add Product
</button>

</form>

</div>

</div>

)

}

export default UploadProduct